// extracted by mini-css-extract-plugin
module.exports = {"offers":"_2hQKp_","offer":"_1BYSoM"};